"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var DEFAULTS = {
  betas: [],
  compositionId: null,
  features: {},
  // FM will throw if this isn't passed, which is intended
  fileManagerUploadedFileAccess: undefined,
  fullScreen: false,
  richTextStyles: {},
  usageTracker: {
    trackInteraction: function trackInteraction() {}
  }
};

var ComposerSettings = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(ComposerSettings, _Record);

  function ComposerSettings() {
    (0, _classCallCheck2.default)(this, ComposerSettings);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ComposerSettings).apply(this, arguments));
  }

  (0, _createClass2.default)(ComposerSettings, null, [{
    key: "fromJS",
    value: function fromJS(data) {
      return new ComposerSettings(data);
    }
  }]);
  return ComposerSettings;
}((0, _immutable.Record)(DEFAULTS));

exports.default = ComposerSettings;
module.exports = exports.default;